import * as tslib_1 from "tslib";
import { Component, Ref, Vue } from "vue-property-decorator";
import { scrollTop } from "@/utils/scroll-to";
import { getCourseList, changeStatus, copyCourseContent } from "@/api/course";
import { mixin_export } from '@/utils/exportFile';
let CourseManage = class CourseManage extends Vue {
    constructor() {
        super(...arguments);
        this.courseStatus = [
            {
                name: "全部状态",
                value: '',
            },
            {
                name: "启用",
                value: '1',
            },
            {
                name: "停用",
                value: '2',
            },
        ];
        this.courseUpdateStatus = [
            {
                name: "全部状态",
                value: '',
            },
            {
                name: "更新中",
                value: '1',
            },
            {
                name: "已完结",
                value: '2',
            },
        ];
        this.isCourseLoading = false; // 课程列表加载状态
        this.courseList = []; // 课程列表
        // 课程列表分页器
        this.paginator = {
            pageNo: 1,
            total: 0,
            pageSize: 10,
        };
        // 课程搜索器
        this.courseFilter = {
            nameOrId: "",
            createTime: null,
            status: '',
            updateType: '' // 1更新中 2已完结
        };
        // 课程搜索器缓存数据 用于实际发起请求
        this.courseFilterCache = {};
    }
    created() {
        this.getCourseList();
    }
    // 获取课程列表
    async getCourseList(filter) {
        this.isCourseLoading = true;
        const query = {
            pageNo: this.paginator.pageNo,
            pageSize: this.paginator.pageSize
        };
        // 合并请求数据
        Object.assign(query, filter || this.courseFilterCache);
        const res = await getCourseList(query);
        if (res.data.status !== 200)
            return this.$message.error(res.data.msg);
        const data = res.data.data;
        if (!data)
            return;
        this.courseList = data.list.map((course) => {
            return {
                id: course.id,
                name: course.name,
                cover: course.picUrl,
                description: course.description,
                type: course.type,
                updatedCount: course.updatePeriod,
                totalCount: course.totalPeriod,
                studyCount: course.studyCount,
                createTime: course.createTime,
                recentTime: course.updateTime,
                status: course.status,
                updatePeriod: course.updatePeriod,
                updateBy: course.updateBy,
                updateTime: course.updateTime,
                updateType: course.updateType,
            };
        });
        this.$nextTick(this.courseListTable.doLayout);
        this.paginator.total = Number(data.total);
        this.isCourseLoading = false;
    }
    // 搜索课程
    handleCourseSearch() {
        const filter = this.courseFilter;
        const query = {};
        if (filter.nameOrId !== "") {
            query.searchContent = filter.nameOrId;
        }
        if (filter.status !== '') {
            query.status = filter.status;
        }
        if (filter.updateType !== '') {
            query.updateType = filter.updateType;
        }
        if (filter.createTime) {
            query.startDate = filter.createTime[0];
            query.endDate = filter.createTime[1];
        }
        this.courseFilterCache = query; // 缓存课程列表搜索数据
        this.paginator.pageNo = 1;
        this.getCourseList(query);
    }
    // 分页器换页
    handleCoursePageChange(pageNo) {
        this.paginator.pageNo = pageNo;
        // 先滚动到列表顶部再刷新列表
        scrollTop(document.getElementsByClassName("app-main")[0], 0, 233, this.getCourseList);
    }
    changePageSize(pageSize) {
        this.paginator.pageSize = pageSize;
        // 先滚动到列表顶部再刷新列表
        scrollTop(document.getElementsByClassName("app-main")[0], 0, 233, this.getCourseList);
    }
    handleCourseExport() {
        const filter = this.courseFilter;
        const query = {};
        if (filter.nameOrId !== "") {
            query.searchContent = filter.nameOrId;
        }
        if (filter.status !== '') {
            query.status = filter.status;
        }
        if (filter.updateType !== '') {
            query.updateType = filter.updateType;
        }
        if (filter.createTime) {
            query.startDate = filter.createTime[0];
            query.endDate = filter.createTime[1];
        }
        mixin_export('/courseAdmin/course/exportColumn', 'get', query);
    }
    onEdit(id) {
        this.$router.push({ path: '/course-manager/columnAdd', query: {
                id
            } });
    }
    onChangeCourseStatus(props) {
        this.$confirm(`是否${props.status == 1 ? '停用' : '启用'}？`, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
        }).then(async () => {
            let data = {
                id: props.id,
                status: props.status == 1 ? 2 : 1
            };
            const res = await changeStatus(data);
            if (res.data.status !== 200)
                return this.$message.error(res.data.msg);
            this.$message({
                type: 'success',
                message: '修改成功'
            });
            this.getCourseList();
        }).catch(() => {
        });
    }
    onDel(props) {
        this.$confirm(`是否确认删除？`, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
        }).then(async () => {
            let data = {
                id: props.id,
                status: 0
            };
            const res = await changeStatus(data);
            if (res.data.status !== 200)
                return this.$message.error(res.data.msg);
            this.$message({
                type: 'success',
                message: '删除成功'
            });
            this.getCourseList();
        }).catch(() => {
        });
    }
    onCopy(props) {
        this.$confirm(`是否确认复制？`, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
        }).then(async () => {
            let data = {
                id: props.id
            };
            const res = await copyCourseContent(data);
            if (res.data.status !== 200)
                return this.$message.error(res.data.msg);
            this.$message({
                type: 'success',
                message: '复制成功'
            });
            this.getCourseList();
        }).catch(() => {
        });
    }
    onJump(props) {
        this.$router.push({ path: '/course-manager/studentList', query: {
                id: props.id
            } });
    }
};
tslib_1.__decorate([
    Ref()
], CourseManage.prototype, "courseListTable", void 0);
CourseManage = tslib_1.__decorate([
    Component({
        name: "courseManage",
    })
], CourseManage);
export default CourseManage;
